import React, { useEffect, useState, useImperativeHandle } from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import { isBizNull } from "../../utils";
import { getCountryList } from "../../services/siteService";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import InputPhoneNumber from "../../elements/InputPhoneNumber";

const ContactInformation = React.forwardRef((props, ref) => {
  const {
    lang,
    isDisabled,
    formData,
    fields: { heading, emailLabel, emailMissingMessage, emailWarningMessage, phoneAreaLabel, phoneLabel, phoneMissingMessage, phoneWarningMessage /*, onChange: onInputFieldChanged*/ },
    user
  } = props;
  const [emailEntered, setEmailEntered] = useState("");
  /*"29713862@qq.com"*/
  const [emailIsValid, setEmailIsValid] = useState(true);
  const [emailError, setEmailError] = useState(null);
  const [areaCodeList, setAreaCodeList] = useState([]);
  const [phoneAreaEntered, setPhoneArea] = useState("");
  const [phoneNumberEntered, setPhoneNumber] = useState("");
  /*"18055666655"*/
  const [phoneAreaIsValid, setPhoneAreaIsValid] = useState(true);
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [phoneError, setPhoneError] = useState(null);

  useImperativeHandle(ref, () => ({
    validateForm
  }));
  useEffect(() => {
    init().then();
  }, []);
  useEffect(() => {
    setEmailEntered(formData?.email || user?.email);
    setPhoneArea(formData?.phoneArea || user?.mobileNoCountryCode);
    setPhoneNumber(formData?.phone || user?.mobileNo);
  }, [areaCodeList, formData, user]);
  const init = async () => {
    const regions = await getCountryList(lang);
    setAreaCodeList(
      regions
        .filter(e => !isBizNull(e.phoneCountryCode))
        .map(e => ({
          value: e.phoneCountryCode,
          code: e.phoneCountryCode
        }))
    );
  };

  const validateForm = () => {
    let isValid = true;

    if (isBizNull(emailEntered)) {
      isValid = false;
      setEmailError(emailMissingMessage.value);
    }
    if (isBizNull(phoneNumberEntered)) {
      isValid = false;
    }
    if (isBizNull(phoneAreaEntered)) {
      isValid = false;
    }

    isValid = isValid && emailIsValid && phoneAreaIsValid && phoneIsValid;
    const formData = {
      email: emailEntered,
      phoneArea: phoneAreaEntered,
      phone: phoneNumberEntered
    };
    return { isValid, formData };
  };

  const emailProps = {
    type: "email",
    label: emailLabel.value,
    value: emailEntered,
    showError: emailError !== null,
    warningMessage: emailError,
    disabled: isDisabled,
    onFocus: evt => {
      setEmailIsValid(true);
      setEmailError(null);
    },
    onChange: (evt, isValid) => {
      setEmailIsValid(isValid);
    },
    onBlur: evt => {
      setEmailEntered(evt.target.value);
      if (!emailIsValid) {
        setEmailError(emailWarningMessage.value);
      }
    }
  };
  const phoneAreaProps = {
    label: phoneAreaLabel.value,
    value: phoneAreaEntered,
    disabled: isDisabled,
    onChange: (evt, isValid) => {
      setPhoneAreaIsValid(isValid);
      setPhoneArea(evt.target.value);
    }
  };
  const phoneProps = {
    label: phoneLabel.value,
    value: phoneNumberEntered,
    disabled: isDisabled,
    onChange: (evt, isValid) => {
      setPhoneIsValid(isValid);
      setPhoneNumber(evt.target.value);
    }
  };
  return (
    <form className="contact-information">
      <Heading className="contact-information__heading" {...heading} />
      <Input name="email" autocomplete="email" {...emailProps} />
      <InputPhoneNumber phoneArea={{ ...phoneAreaProps }} phoneNumber={{ ...phoneProps }} missingMessage={phoneMissingMessage.value} warningMessage={phoneWarningMessage.value} />
    </form>
  );
});
const mapStateToProps = state => ({
  user: selectUserState(state)
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(ContactInformation);
// ContactInformation.propTypes = {
//   heading: PropTypes.object.isRequired
// };
ContactInformation.displayName = "ContactInformation";
ContactInformation.defaultProps = {};
